export default __webpack_public_path__ + "static/media/kakaotalk.342fc4f9.svg";